import { type FeatureModule } from '@store/features/types';

export const jotcoachFeature: FeatureModule = {
  id: 'jotcoach',
  name: 'JotCoach',
  dependencies: [],
  reducers: {},
  middleware: [],
  persistence: { enabled: false },
  sync: { enabled: false },
  setup: _store => {},
  cleanup: _store => {},
};
